import { apiClientTestStat, httpGet } from 'api/api'
import { selectuserInfo } from 'hooks/userInfo'
import moment from 'moment'
import { ChangeEvent, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ContentPasteSearchTwoToneIcon from '@mui/icons-material/ContentPasteSearchTwoTone'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import ReceiptIcon from '@mui/icons-material/Receipt'
import {
    Stack,
    Grid,
    Paper,
    Box,
    Button,
    TextField,
    FormControl,
    InputLabel,
    Typography,
    Select,
    useMediaQuery,
    MenuItem,
    Breadcrumbs,
    FormControlLabel,
    Radio,
    RadioGroup,
    useTheme,
    styled,
    CircularProgress,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from '@mui/material'
import LinearProgress from '@mui/material/LinearProgress'
import { PageBg } from 'components/ComponentStyles'
import {
    DataGridPremium,
    koKR,
    GridColDef,
    GridSelectionModel,
    GridDensity,
    GridRowHeightParams,
    useGridApiRef,
    GridColumnVisibilityModel,
} from '@mui/x-data-grid-premium'
import { getSettings } from 'helpers/storage'
import XLSX from 'xlsx-js-style'
import { alertModal, compareDate, hexToRgba, htmlAlertModal, isValidDateType } from 'util/util'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import 'dayjs/locale/ko'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { SearchRowItem } from 'components/FrameworkStyle'
import ClientSearchPopup from './clientSearchPopup'
import search from 'views/etc/search'
import { SelectChangeEvent } from '@mui/material/Select'
import { selectCmmnCode } from 'hooks/cmmnCodeFactory'
import { extractCmmnCode } from 'util/cmmnCodeUtil'
import { $CombinedState } from '@reduxjs/toolkit'

const locales = ['ko'] as const

const PageBg2 = styled('div')(({ theme }) => ({
	display: 'flex',
	justifyContent: 'space-between',
	alignItems: 'center',
	padding: '1rem',
	borderRadius: '0.5rem',
	background: `${hexToRgba(theme.palette.custom.wrapper, 1)}`,
	// filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.1))',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		flexDirection: 'column',
		borderRadius: 0,
	},
	// backdropFilter: 'blur(10px)',
}))

const PageWrap = styled('div')(({ theme }) => ({
	marginBottom: '1rem',
	position: 'relative',
	top: '0',
	left: '0',
	right: '0',
	zIndex: '110',
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		//marginLeft: '-1.5rem',
		//marginRight: '-1.5rem',
		top: '0',
		//borderRadius: '0',
	},
}))

const BtnBox = styled(Box)(({ theme }) => ({
	// [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
	// 	marginTop: '1rem',
	// },
}))

const TitleText = styled(Typography)(({ theme }) => ({
	[`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
		display: 'none',
	},
}))

type requestType = {
    TargetYear: number
	clientID: number
	DisplayName: string
	searchTestCd: string
}

const initialRequest: requestType = {
    clientID: 0,
    TargetYear: moment().year(),
    DisplayName: '',
    searchTestCd: '0',
}

const formatHeaderName = (label: string) => {
	return label.includes('(') ? label.replace(/\s*\(/, '\n(') : label
}

const formatDiseaseName = (value: unknown) => {
	if (typeof value !== 'string') {
		return value ?? ''
	}

	return value
		.split(',')
		.map((item) => item.trim())
		.filter(Boolean)
		.join('\n')
}

const gridColumns: GridColDef[] = [
    {
        field: 'RepresentTestCode',
        headerName: '검사코드',
        type: 'string',
        flex: 1.1,
        minWidth: 70,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'InsuranceCode',
        headerName: '보험코드',
        type: 'string',
        flex: 1.2,
        minWidth: 80,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'DisplayName',
        headerName: '검사명',
        type: 'string',
        flex: 3,
        minWidth: 180,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'left',
    },
    {
        field: 'SpecimenName',
        headerName: '검체명',
        type: 'string',
        flex: 1.5,
        minWidth: 90,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'left',
    },
    {
        field: '1M',
        headerName: '1월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '2M',
        headerName: '2월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '3M',
        headerName: '3월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '4M',
        headerName: '4월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '5M',
        headerName: '5월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '6M',
        headerName: '6월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '7M',
        headerName: '7월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '8M',
        headerName: '8월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '9M',
        headerName: '9월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '10M',
        headerName: '10월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '11M',
        headerName: '11월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: '12M',
        headerName: '12월',
        type: 'string',
        flex: 0.8,
        minWidth: 45,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
    },
    {
        field: 'TotalCount',
        headerName: '합계',
        type: 'string',
        flex: 1,
        minWidth: 60,
        editable: false,
        disableColumnMenu: true,
        headerAlign: 'center',
        align: 'center',
        cellClassName: 'total-column',
    },
]

const ClientTestStatView = () => {
	const theme = useTheme()
	const isMdUp = useMediaQuery(theme.breakpoints.up('md'))
	const isLgUp = useMediaQuery(theme.breakpoints.up('lg'))
	const [locale] = useState<(typeof locales)[number]>('ko')
	const userInfo = useSelector(selectuserInfo)
	const env = getSettings()
	const gridRef = useGridApiRef()
	const [page, setPage] = useState(0)
	const [size1, setSize1] = useState(env.row ? env.row : 100)
	const [gridIsLoading, setGridIsLoading] = useState(false)
	const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([])


	const [search, setSearch] = useState<requestType>({
		...initialRequest,
		clientID: userInfo.infoType === 'C' ? userInfo.clientID : '', // 거래처id
        TargetYear: moment().year(),
        searchTestCd: '0', 
	})
    

	const disabledReset = false
	const [disabledSearch, setDisabledSearch] = useState(false)
	const [dateRange, setDateRange] = useState('1d')

	const [data, setData] = useState<any[]>([])
	const [testCdList, setTestCdList] = useState<any>([])



    const fetchData = () => {
        console.log('Request:', search)

        setGridIsLoading(true)

        const request = {
            ...search,
            searchTestCd: search.searchTestCd !== '0' ? search.searchTestCd : '',
        }

        console.log('API Request:', request)

        httpGet('/ClientTest/Stat', request)
            .then((res) => {
                console.log(res)
                setData(res)
            })
            .finally(() => {
                setGridIsLoading(false)
            })
    }


    


		useEffect(() => {
			const lv2 = extractCmmnCode(cmmnCdList, 'TEST_CD', 1)
			setTestCdList(lv2?.level2)

			if (userInfo?.infoType === 'C') {
				fetchData()
			}
		}, [])

		
		const excelDownload = () => {
		if (!data || data.length === 0) {
			htmlAlertModal('조회 결과가 없습니다.', 'warning', () => {})
			return
		}

		const excelData = data.map((row) => ({
			검사코드: row.RepresentTestCode,
			보험코드: row.InsuranceCode,
			검사명: row.DisplayName,
			검체명: row.SpecimenName,
			'1월': row['1M'],
			'2월': row['2M'],
			'3월': row['3M'],
			'4월': row['4M'],
			'5월': row['5M'],
			'6월': row['6M'],
			'7월': row['7M'],
			'8월': row['8M'],
			'9월': row['9M'],
			'10월': row['10M'],
			'11월': row['11M'],
			'12월': row['12M'],
			합계: row.TotalCount,
		}))

		const worksheet = XLSX.utils.json_to_sheet(excelData)
		worksheet['!cols'] = [
			{ wch: 15 }, // A 검사코드
			{ wch: 20 }, // B 보험코드
			{ wch: 40 }, // C 검사명
			{ wch: 20 }, // D 검체명
			{ wch: 10}, // E 1월
			{ wch: 10 }, // F 2월
			{ wch: 10 }, // G 3월
			{ wch: 10 }, // H 4월
			{ wch: 10 }, // I 5월
			{ wch: 10 }, // J 6월
			{ wch: 10 }, // K 7월
			{ wch: 10 }, // L 8월
			{ wch: 10 }, // M 9월
			{ wch: 10 }, // N 10월
			{ wch: 10 }, // O 11월
			{ wch: 10 }, // P 12월
			{ wch: 12 }, // Q 합계
		]

		const workbook = XLSX.utils.book_new()

		XLSX.utils.book_append_sheet(workbook, worksheet, 'sheet1')

		XLSX.writeFile(
			workbook,
			`${search.TargetYear}년 신원의료재단 의뢰검사 건수통계.xlsx`,
		)
		}

	// 내부사용자일 경우 거래처 선택 팝업
    
	const [clientDialogOpen, setClientDialogOpen] = useState(false)
	const [searchClientName, setSearchClientName] = useState('')
	const clientDialogClose = () => {
		setClientDialogOpen(false)
	}
	const clientPopupOpenAction = () => {
		setClientDialogOpen(true)
	}
	const clientPopupSubmit = (e: any) => {
		console.log(e)
		setSearchClientName(e.ClientName)
		setSearch({
			...search,
			clientID: e.ClientID,
		})
		setClientDialogOpen(false)
	}

	const actionReset = () => {
		setSearch({
			...initialRequest,
			clientID: userInfo.infoType === 'C' ? userInfo.clientID : '', // 거래처id
            searchTestCd: '0',
            DisplayName: '',
		})
	}
	const actionSearch = () => {
		if (!disabledSearch) fetchData()
	}

	const onKeyUp = (e: any) => {
		if (e.keyCode === 13) actionSearch()
	}


    const handleChange = (
        event: 
            | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
            | SelectChangeEvent<string>
    ) => {
        const { name, value } = event.target

        setSearch({
            ...search,
            [name]: name === 'TargetYear' ? Number(value) : value,
        })
    }
    const currentYear = moment().year();
    const yearOptions = Array.from({ length: currentYear - 2023 + 1 }, (_, i) => currentYear - i);
    const cmmnCdList = useSelector(selectCmmnCode)


	return (
		<>
			<ClientSearchPopup
				dialogOpen={clientDialogOpen}
				dialogClose={clientDialogClose}
				popupSubmit={clientPopupSubmit}
			/>

			
			<Stack
				sx={{
					position: 'sticky',
					top: '50px',
					zIndex: 100,
					padding: '0.5rem',
					borderRadius: '0.5rem',
					backgroundColor:
						theme.palette.mode === 'dark' ? 'rgba(50, 48, 54, 1)' : '#fff',
					'@media (max-width: 600px)': {
						position: 'relative',
						paddingTop: '15px',
						top: '0px',
					},
				}}
			>
				<PageWrap style={{ marginBottom: '0.5rem' }}>
					<PageBg2 sx={{ padding: '0.3rem 0.3rem 0rem 0.5rem' }}>
						<Breadcrumbs
							separator={<NavigateNextIcon fontSize="small" />}
							aria-label="breadcrumb"
							sx={{
								'@media (max-width: 900px': {
									display: 'none',
								},
							}}
						>
							<TitleText
								key="3"
								color="text.primary"
								sx={{ fontWeight: '500', fontSize: 17 }}
							>
								검사 건수 통계 (
								{userInfo.infoType === 'C' ? (
									<>{userInfo.clientName}</>
								) : (
									searchClientName
								)}
								)
							</TitleText>
						</Breadcrumbs>
						<BtnBox>
							<div>
								<span>
									<Button
										size="small"
										color="success"
										variant="contained"
										startIcon={isMdUp && <RotateLeftIcon />}
										sx={{
											marginRight: '0.5rem',
											padding: isMdUp ? '4px 10px' : '4px 6px',
											minWidth: isMdUp ? '64px' : '50px',
										}}
										disabled={disabledReset}
										onClick={actionReset}
									>
										초기화
									</Button>
								</span>
								<span>
									<Button
										color="primary"
										variant="contained"
										startIcon={<ContentPasteSearchTwoToneIcon />}
										onClick={actionSearch}
										size="small"
										disabled={disabledSearch}
										sx={{ marginRight: '0.5rem' }}
									>
										조회
									</Button>
								</span>
								<span>
									<Button
										color="secondary"
										size="small"
										variant="contained"
										startIcon={<ReceiptIcon />}
										sx={{ marginRight: '0.5rem' }}
										onClick={excelDownload}
										// disabled={isRptType0 ? true : false}
									>
										다운로드
									</Button>
								</span>
							</div>
						</BtnBox>
					</PageBg2>
				</PageWrap>
				<Box
					component="form"
					noValidate
					autoComplete="off"
					onKeyUp={onKeyUp}
					sx={{
						borderTop:
							theme.palette.mode === 'dark'
								? '1px solid rgba(81, 81, 81, 1)'
								: '1px solid #ccc',
						paddingTop: '1rem',
					}}
				>
					<LocalizationProvider
						dateAdapter={AdapterDayjs}
						adapterLocale={locale}
					>
					<SearchRowItem>
						<p className="labelText">조회조건</p>

						<Grid container spacing={1}>
							{/* 조회연도 */}
							<Grid
								item
								xs={
									userInfo.infoType === 'S' || userInfo.infoType === 'W'
										? 6
										: 4
								}
								md="auto"
							>
								<TextField
									select
									label="조회연도"
									size="small"
									name="TargetYear"
									value={search.TargetYear}
									onChange={handleChange}
									fullWidth
									sx={{
										width: {
											xs: '100%',
											md: 250,
										},
									}}
								>
									{yearOptions.map((year) => (
										<MenuItem key={year} value={year}>
											{year}년
										</MenuItem>
									))}
								</TextField>
							</Grid>

							{/* 학부(파트) */}
							<Grid
								item
								xs={
									userInfo.infoType === 'S' || userInfo.infoType === 'W'
										? 6
										: 4
								}
								md="auto"
							>
								<FormControl
									fullWidth
									sx={{
										width: {
											xs: '100%',
											md: 250,
										},
									}}
								>
									<InputLabel id="date-range-select-label">
										학부(파트)
									</InputLabel>

									<Select
										labelId="date-range-select-label"
										label="학부(파트)"
										name="searchTestCd"
										value={search.searchTestCd}
										onChange={handleChange}
										size="small"
									>
										<MenuItem value="0">전체</MenuItem>

										{testCdList &&
											testCdList.length > 0 &&
											testCdList.map(
												(item: {
													id: number
													cmmnCd: string
													cmmnNm: string
												}) => (
													<MenuItem
														key={item.id}
														value={item.cmmnCd}
													>
														{item.cmmnNm}
													</MenuItem>
												),
											)}
									</Select>
								</FormControl>
							</Grid>

							{/* 검사명 */}
							<Grid
								item
								xs={
									userInfo.infoType === 'S' || userInfo.infoType === 'W'
										? 6
										: 4
								}
								md="auto"
							>
								<TextField
									label="검사명"
									variant="outlined"
									size="small"
									type="text"
									value={search.DisplayName}
									fullWidth
									sx={{
										width: {
											xs: '100%',
											md: 250,
										},
									}}
									onChange={(e) => {
										setSearch({
											...search,
											DisplayName: e.target.value,
										})
									}}
								/>
							</Grid>

							{/* 거래처 - 마스터 계정만 */}
							{(userInfo.infoType === 'S' ||
								userInfo.infoType === 'W') && (
								<Grid
									item
									xs={6}
									md="auto"
								>
									<TextField
										label="거래처"
										variant="outlined"
										size="small"
										type="text"
										fullWidth
										sx={{
											width: {
												xs: '100%',
												md: 250,
											},
										}}
										aria-readonly={true}
										value={searchClientName}
										onClick={clientPopupOpenAction}
									/>
								</Grid>
							)}
						</Grid>
					</SearchRowItem>
					</LocalizationProvider>
				</Box>
			</Stack>
			<Paper
				id="back-to-top"
				elevation={0}
				sx={{
					width: '100%',
					backgroundColor: 'transparent',
					overflow: 'hidden',
				}}
			>
				<Grid container>
					<Grid item xs={12}>
						<PageBg style={{ marginTop: '1rem' }}>
							<Box
								sx={{
									marginTop: '1rem',
									width: '100%',
									height: 'calc(100vh - 276px)',
									minHeight: 0,
									overflow: 'hidden',
								}}
							>
								<DataGridPremium
									apiRef={gridRef}
									page={page}
									onPageChange={(newPage) =>
										setPage(newPage)
									}

									rows={data}

									getRowId={(row) =>
										`${row.RepresentTestCode}-${row.InsuranceCode}-${row.SpecimenName}`
									}

									columns={gridColumns}

									headerHeight={60}

									pageSize={size1}
									onPageSizeChange={(newPageSize) =>
										setSize1(newPageSize)
									}

									rowsPerPageOptions={[
										5,
										10,
										20,
										50,
										100,
										500,
										1000,
									]}

									pagination
									autoHeight={false}

									localeText={{
										...koKR.components.MuiDataGrid.defaultProps
											.localeText,
										noRowsLabel:
											'조회 결과가 없습니다.',
									}}

									components={{
										LoadingOverlay: LinearProgress,
									}}

									loading={gridIsLoading}

									density={
										(env.desnse as GridDensity) ||
										'compact'
									}

									sx={{
										width: '100%',
										height: '100%',

										'& .MuiDataGrid-columnHeaderTitleContainer': {
											fontSize: '13px',
											justifyContent: 'center',
											alignItems: 'center',
											height: '100%',
											overflow: 'hidden',
										},

										'& .MuiDataGrid-columnHeaderTitleContainerContent':
											{
												display: 'flex',
												justifyContent: 'center',
												alignItems: 'center',
												width: '100%',
												overflow: 'hidden',
											},

										'& .MuiDataGrid-columnHeaderTitle': {
											whiteSpace: 'nowrap',
											lineHeight: 1.3,
											textAlign: 'center',
											width: '100%',
											overflow: 'hidden',
											textOverflow: 'ellipsis',
										},

										'& .MuiDataGrid-columnHeader': {
											paddingTop: '4px',
											paddingBottom: '4px',
										},

										'& .MuiDataGrid-cell': {
											fontSize: '13px !important',
											alignItems: 'center',
											paddingLeft: '6px',
											paddingRight: '6px',
											borderRight:
												theme.palette.mode === 'dark'
													? '1px solid rgba(81, 81, 81, 1)'
													: '1px solid rgba(224, 224, 224, 1)',
										},

										'& .MuiDataGrid-row:hover': {
											backgroundColor:
												'rgba(0,0,0,0.06) !important',
										},

										'& .Mui-selected:hover': {
											backgroundColor:
												'rgba(75, 123, 236, 0.08) !important',
										},

										'& .Mui-disabled': {
											color:
												'rgba(0, 0, 0, 0.1) !important',
										},

										// 합계 열 강조
										'& .total-column': {
											backgroundColor:
												theme.palette.mode === 'dark'
													? 'rgba(255,255,255,0.06)'
													: '#f5f5f5',
											fontWeight: 'bold',
										},
									}}
								/>
							</Box>
						</PageBg>
					</Grid>
				</Grid>
			</Paper>
		</>
	)
}

  
export default ClientTestStatView
